export enum AgentViewWorkspaceCapabilityAccessOperation {
    create = "2f6e8690-1545-4bc8-8461-284836d8993f",
    read = "e762a49a-06c3-40e5-9b5f-5afd5663ef93",
    update = "dd2ea85f-c5ce-4954-96fc-9cf44865141e",
    delete = "150221a9-2793-4091-8557-3edb30a79214",
}
